/**
 * Floating coffee-bean canvas for the site-wide #tng-backdrop (see
 * snippets/tng-global.liquid / assets/tng-backdrop.css). Same particle
 * system used to live only in the homepage's Tuang Immersive section;
 * now runs once, globally, behind every page.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var canvas = document.getElementById('tng-backdrop__canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  if (!ctx) return;

  var W = 0, H = 0, beans = [], running = false;

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth; H = window.innerHeight;
    canvas.width = W * dpr; canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function makeBean() {
    return {
      x: Math.random() * W, y: H + Math.random() * H, s: 6 + Math.random() * 10,
      vy: 0.2 + Math.random() * 0.5, vx: (Math.random() - 0.5) * 0.3,
      rot: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.01,
      a: 0.05 + Math.random() * 0.12
    };
  }
  function initBeans() {
    beans = [];
    var n = Math.min(34, Math.round(W / 44));
    for (var i = 0; i < n; i++) { var b = makeBean(); b.y = Math.random() * H; beans.push(b); }
  }
  function drawBean(b) {
    ctx.save();
    ctx.translate(b.x, b.y);
    ctx.rotate(b.rot);
    ctx.globalAlpha = b.a;
    ctx.fillStyle = '#e9c893';
    ctx.beginPath(); ctx.ellipse(0, 0, b.s * 0.62, b.s, 0, 0, Math.PI * 2); ctx.fill();
    ctx.globalAlpha = b.a * 1.5;
    ctx.strokeStyle = '#3a1d10';
    ctx.lineWidth = Math.max(1, b.s * 0.12);
    ctx.beginPath(); ctx.moveTo(0, -b.s * 0.8); ctx.quadraticCurveTo(b.s * 0.28, 0, 0, b.s * 0.8); ctx.stroke();
    ctx.restore();
  }
  function loop() {
    if (!running) return;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < beans.length; i++) {
      var b = beans[i];
      b.y -= b.vy; b.x += b.vx; b.rot += b.vr;
      if (b.y < -30) beans[i] = makeBean();
      drawBean(beans[i]);
    }
    requestAnimationFrame(loop);
  }
  function start() { if (!running) { running = true; loop(); } }
  function stop() { running = false; }

  resize();
  initBeans();
  start();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { resize(); initBeans(); }, 200);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
})();
